<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/customers/incomes/form' }">
        <a-button icon="plus" type="primary">新建收支</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="vertical">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.contents"
              placeholder="请输入要搜索的关键词"
              enter-button
              allow-clear
              @search="getIncomeLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="客户">
                <a-spin :spinning="customersLoading">
                  <a-select
                    allow-clear
                    placeholder="请选择客户"
                    v-model="params.where.customer_id"
                    optionFilterProp="children"
                    @change="getIncomeLists()"
                  >
                    <a-select-option v-for="key in customersList" :key="key.id">
                      {{ key.name }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="合同">
                <a-spin :spinning="selectLoading">
                  <a-select
                    allow-clear
                    placeholder="请选择客户"
                    v-model="params.where.contract_id"
                    optionFilterProp="children"
                    @change="getIncomeLists()"
                  >
                    <a-select-option v-for="key in selectList" :key="key.id">
                      {{ key.name }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="证书">
                <a-spin :spinning="crtsLoading">
                  <a-select
                    allow-clear
                    placeholder="请选择证书"
                    v-model="params.where.certificates"
                    optionFilterProp="children"
                    @change="getIncomeLists()"
                  >
                    <a-select-option v-for="key in crtsList" :key="key.id.toString()">
                      {{ key.title }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="日期范围">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="value => handleChangeDate(value,['date_start', 'date_end'],'price_sum')"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false" title="收支列表">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getIncomeLists()"
        />

      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="money" slot-scope="cord">
          <span style="color: red">￥{{ (cord / 100) | NumberFormat }}</span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <router-link v-action:update :to="{ path: '/customers/incomes/form/' + record.id }">
            <a-button type="link" size="small">编辑</a-button>
          </router-link>
          <a-divider type="vertical" v-action:update />
          <a-popconfirm
            title="确定要删除该信息吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleOnDelete(record.id)"
            v-action:delete
            style="margin-left:.75rem"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </template>
        <template slot="footer"> 订单累计金额：{{ price_sum }} </template>

      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList } from '@/components'
const apiList = {
    getList: '/customers/incomes',
    delete: '/customers/incomes/',
    selectList: '/customers/contracts/select',
    customersList: '/customers/select',
    crtsList: '/certificates/select'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '客户名称',
        dataIndex: 'customer.name'
    },
    {
        title: '合同名称',
        dataIndex: 'contract.name'
    },
    {
        title: '证书考试码',
        dataIndex: 'certificates'
    },
    {
        title: '数量',
        dataIndex: 'number'
    },
    {
        title: '收款日期',
        dataIndex: 'date'
    },
    {
        title: '收款金额',
        dataIndex: 'money',
        scopedSlots: { customRender: 'money' }
    },
    {
        title: '备注',
        dataIndex: 'remark'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'IncomesList',
    mixins: [list, table, select], // 使用mixins
    components: {
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            selectLoading: false, // 分类下拉加载
            selectList: [], // 分类下拉数据
            crtsLoading: false, // 课程下拉加载
            crtsList: [], // 课程下拉数据
            customersLoading: false,
            customersList: [],
            price_sum: 0,
            scroll: {
                x: 1200
            }
        }
    },
    mounted () {
       this.getIncomeLists()
        this.getSelectLists({
            url: apiList.selectList
        })
        this.getSelectLists({
            url: apiList.customersList,
            type: 'customersList',
            load: 'customersLoading'
        })
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoading'
        })
    },
    methods: {
        getIncomeLists () {
              this.getLists('price_sum')
        }
    }
}
</script>
